<template>
  <div class="page active">
    <div class="header">
      <button class="back-btn" @click="goBack">&lt; 返回</button>
      <h1>东莞拍摄</h1>
    </div>

    <div class="np-tabs">
      <button class="np-tab-item" :class="{ active: activeTab === 'warehouse' }" @click="activeTab = 'warehouse'">仓库端</button>
      <button class="np-tab-item" :class="{ active: activeTab === 'photographer' }" @click="activeTab = 'photographer'">摄影师端</button>
    </div>

    <div class="np-content">
      <div class="np-title">请选择作业</div>

      <button v-if="activeTab === 'warehouse'" class="np-entry-card" @click="goTo('beiyang')">
        <div class="np-entry-icon np-icon-beiyang" aria-hidden="true">
          <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="none">
            <circle cx="32" cy="32" r="28" fill="#dbeafe"/>
            <path d="M16 28h32v16a4 4 0 01-4 4H20a4 4 0 01-4-4V28z" fill="#3b82f6" opacity=".7"/>
            <path d="M14 22h36a2 2 0 012 2v4H12v-4a2 2 0 012-2z" fill="#2563eb"/>
            <path d="M26 22V20a2 2 0 012-2h8a2 2 0 012 2v2" stroke="#2563eb" stroke-width="2"/>
          </svg>
        </div>
        <div class="np-entry-name">【备样】</div>
        <div class="np-entry-desc">组装准备给摄影师的样品</div>
      </button>

      <button v-if="activeTab === 'warehouse'" class="np-entry-card np-entry-card-green" @click="goTo('shouyang')">
        <div class="np-entry-icon np-icon-shouyang" aria-hidden="true">
          <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="none">
            <circle cx="32" cy="32" r="28" fill="#d1fae5"/>
            <rect x="16" y="22" width="24" height="20" rx="3" fill="#10b981" opacity=".7"/>
            <path d="M34 18h8a2 2 0 012 2v24" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
            <path d="M28 32l4 4 8-8" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M40 26l4-4M40 30V22h-8" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="np-entry-name">【收样】</div>
        <div class="np-entry-desc">接收摄影师归还的样品</div>
      </button>

      <button v-if="activeTab === 'photographer'" class="np-entry-card np-entry-card-purple" @click="goTo('huanyang')">
        <div class="np-entry-icon np-icon-huanyang" aria-hidden="true">
          <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="none">
            <circle cx="32" cy="32" r="28" fill="#e0e7ff"/>
            <circle cx="32" cy="24" r="7" fill="#6366f1" opacity=".8"/>
            <path d="M18 44c0-7.732 6.268-14 14-14s14 6.268 14 14" stroke="#6366f1" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M38 36l4-4-4-4M42 32H30" stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="np-entry-name">【还样】</div>
        <div class="np-entry-desc">拍摄完成后登记样品归还</div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DongguanIndex',
  data() {
    return { activeTab: 'warehouse' }
  },
  methods: {
    goBack() {
      this.$router.push('/new-product/index')
    },
    goTo(type) {
      this.$router.push(`/new-product/beiyang-list?type=${type}`)
    }
  }
}
</script>

<style scoped>
.np-tabs {
  display: flex;
  background: #fff;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

.np-tab-item {
  flex: 1;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  padding: 13px 0;
  color: #666;
  font-size: 15px;
}

.np-tab-item.active {
  color: #1890ff;
  font-weight: 600;
  border-bottom-color: #1890ff;
}

.np-content {
  flex: 1;
  overflow-y: auto;
  padding: 22px 16px;
  -webkit-overflow-scrolling: touch;
}

.np-title {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

.np-entry-card {
  width: 100%;
  background: #fff;
  border: 2px solid transparent;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  padding: 28px 20px 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
  font: inherit;
  color: inherit;
}

.np-entry-card:active {
  transform: scale(0.98);
}

.np-entry-card-green {
  border-color: #d1fae5;
}

.np-entry-card-purple {
  border-color: #e0e7ff;
}

.np-entry-icon {
  width: 72px;
  height: 72px;
  margin-bottom: 14px;
}

.np-entry-icon svg {
  width: 100%;
  height: 100%;
}

.np-entry-name {
  font-size: 17px;
  font-weight: 700;
  color: #222;
  margin-bottom: 6px;
}

.np-entry-desc {
  font-size: 13px;
  color: #888;
  text-align: center;
}
</style>
